import { Solution } from './solution';

export var englishSolutions: Solution[] = [
  {
    name: 'Security',
    iconepath: '../assets/icons/security.png',
    activities: [
      'Web Watch',
      'Infrastructure Monitoring'
    ],
    marque: '../../assets/logos/dnred.jpeg',
    usecase: 'Describe UseCase here; Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    descriptions: [
      'Describe Solution here',
    ],
    benefits: [
      'benefit 1',
      'benefit 2',
      'benefit 3',
    ],
    selected: true,
    ios: '',
    android: '',
  },
  {
    name: 'Retail',
    iconepath: '../assets/icons/retail.png',
    activities: [
      'Visual Shopping',
      'Inventory'
    ],
    marque: '../../assets/logos/kingjouet.png',
    usecase: 'Describe UseCase here; Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    descriptions: [
      'Lorem ipsum dolor sit amet',
    ],
    benefits: [
      'benefit 1',
      'benefit 2',
      'Retail benefit 3',
    ],
    selected: true,
    ios: 'https://itunes.apple.com/app/id1167379619',
    android: 'https://play.google.com/store/apps/details?id=com.globevip.toyscan'
  },
  {
    name: 'Industry',
    iconepath: '../assets/icons/industry.png',
    activities: [
      'Quality Control',
      'Contamination Detection'
    ],
    marque: '../../assets/logos/edf.png',
    usecase: 'Describe UseCase here; Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    descriptions: [
      'Lorem ipsum dolor sit amet'
    ],
    benefits: [
      'benefit 1',
      'benefit 2',
      'benefit 3',
      'Industry benefit 4'
    ],
    selected: true,
    ios: '',
    android: '',
  },
  {
    name: 'Com',
    iconepath: '../assets/icons/com.png',
    activities: [
      'Interactive Print',
      'Interactive Booth'
    ],
    marque: '../../assets/logos/ibm.png',
    usecase: 'Describe UseCase here; Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    descriptions: [
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit'
    ],
    benefits: [
      'benefit 1',
      'benefit 2',
    ],
    selected: true,
    ios: '',
    android: '',
  },
  {
    name: 'Software',
    iconepath: '../assets/icons/software.png',
    activities: [
      'Digital Asset Management',
      'Search Engine'
    ],
    marque: '',
    usecase: 'Describe UseCase here; Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    descriptions: [
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'
  ],
    benefits: [
      'benefit 1',
      'benefit 2',
      'benefit 3',
      'benefit 4'
    ],
    selected: true,
    ios: '',
    android: '',
  },
];

// ************************************************************ //

export var frenchSolutions: Solution[] = [
  {
    name: 'Sécurité',
    iconepath: '../assets/icons/security.png',
    activities: [
      'Surveillance sur internet',
      'Conformité RGPD'
    ],
    marque: '../../assets/logos/dnred.jpeg',
    usecase: 'eyeSnap surveille des marketplaces sur internet pour retrouver des contrefaçons à partir des images des produits recherchés.',
    descriptions: [
      'Développement d\’une plateforme big data de collecte d’images',
      'Service d’analyse d’images par deep learning levant une alerte si un produit ciblé est reconnu',
      'Service de reporting adapté aux besoins du client'
    ],
    benefits: [
      'Automatisation du processus de recherche sur des dizaines de millions d\'images',
      'Découverte automatique de nouveaux sites à scanner',
      'Gain de temps pour les équipes de veille sur internet',
    ],
    selected: true,
    ios: '',
    android: '',
  },
  {
    name: 'Retail',
    iconepath: '../assets/icons/retail.png',
    activities: [
      'Inventaire',
      'Shopping visuel'
    ],
    marque: '../../assets/logos/kingjouet.png',
    usecase: 'Avec l’application ToyScan, véritable "Shazam du jouet", eyeSnap permet de mettre un jouet  dans votre panier d’achat ou d’accéder à sa notice à partir d’une simple photo de son packaging.',
    descriptions: [
      'Indexation continue d’environ 100 000 images de jouets et du contenu digital associé',
      'Applications mobiles sur iOS et Android',
      'Backoffice dédié de visualisation des analytics stratégiques',
  ],
    benefits: [
      'Nouveau canal de vente dans la stratégie omnicanale du groupe King Jouet',
      'Animation ludique et innovante autour d’un jouet dans un magasin physique',
      'Analytics sur les produits les plus flashés pour adapter la logistique en conséquence',
    ],
    selected: true,
    ios: 'https://itunes.apple.com/app/id1167379619',
    android: 'https://play.google.com/store/apps/details?id=com.globevip.toyscan'
  },
  {
    name: 'Industrie',
    iconepath: '../assets/icons/industry.png',
    activities: [
      'Contrôle qualité',
      'Aide à la maintenance'
    ],
    marque: '../../assets/logos/edf.png',
    usecase: 'EDF et eyeSnap imaginent ensemble un dispostif mobile permettant aux techniciens de maintenance de la centrale thermique de Port-Est de pouvoir acceder en une photo à l\'identification de la pièce industrielle à changer et à sa disponibilité en stock.',
    descriptions: [
      'Scénarisation de l’usage et mise en place du processus d’acquisition des pièces industrielles',
      'Application mobile à destination des opérateurs de maintenance',
      'Solution d’intelligence artificielle permettant de discriminer finement chacune des pièces à partir de leur image',
    ],
    benefits: [
      'Amélioration des conditions de travail des opérateurs de maintenance sur site',
      'Gain de temps lors d’une opération de maintenance',
      'Possibilité d\'étendre l\'application à la formation professionnelle'
    ],
    selected: true,
    ios: '',
    android: '',
  },
  {
    name: 'Com\'',
    iconepath: '../assets/icons/com.png',
    activities: [
      'Impression Interactive',
      'Stand Interactif'
    ],
    marque: '../../assets/logos/ibm.png',
    usecase: 'En collaboration avec PHB events lors du salon "API Days", eyeSnap propose de rendre le stand IBM interactif via un iPad. Passer le flux video de l’iPad devant un pictogramme IBM déclenche instantanément un instant gagnant !',
    descriptions: [
      'Réalisation de la solution en partenariat avec la société d\'événementiel PHB events',
      'Application mobile sur iPad, sans connexion réseau, intégrant 50 pictogrammes différents',
      'Chaque pictogramme identifié par eyeSnap déclenche l\'instant gagnant associé',
    ],
    benefits: [
      'Génération de trafic supplémentaire sur un événement, un salon',
      'Innovation d\'usage avec un retour très positif des utilisateurs',
      'Contribution positive à l’image du client final'
    ],
    selected: true,
    ios: '',
    android: '',
  },
  {
    name: 'Logiciel',
    iconepath: '../assets/icons/software.png',
    activities: [
      'Gestion de contenus',
      'Moteur de recherche visuel'
    ],
    marque: '../../assets/logos/scoring_media.jpg',
    usecase: 'eyeSnap permet de retrouver des images de publicités à des formats différents dans des centaines de magazines numérisés.',
    descriptions: [
      'Intégration de l\'API eyeSnap dans le back-end de scoring media',
      'Ingestion continue de nouveaux magazines (quotidiens, hebdomadaires et mensuels) et de nouvelles publicités',
      'Clipping automatique des publicités de différents formats trouvées dans le média'
    ],
    benefits: [
      'Gain de temps et de productivité d\'un facteur 10',
      'Nouvelles tâches plus valorisantes pour les équipes annotant manuellement les publicités',
      'Possibilité d\'étendre ce service à d\'autres sources média (web,TV)'
    ],
    selected: true,
    ios: '',
    android: '',
  },
];
